var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',{staticClass:"mt-5"},[_vm._v("Performance Objectives")]),_vm._l((_vm.objectives),function(objective){return _c('placements-performance-item-read-only',{key:objective.id,attrs:{"objective":objective}})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }